"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullValue = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const NullValueContainer = styled_components_1.default.span `
  user-select: none;
  color: ${(props) => props.theme.colors.textDark};
`;
/**
 * To be displayed in tables or data lists to represent null values.
 */
const NullValue = () => react_1.default.createElement(NullValueContainer, null, "\u2014");
exports.NullValue = NullValue;
exports.default = exports.NullValue;
